import { useDocument, usePatchDocument } from '@/hooks';
import { Button } from '@/ui';

import { api } from '@/store/api';
import { useAppDispatch } from '@/store/hooks';

const Publish = () => {
  const dispatch = useAppDispatch();
  const { currentDocument, isDocumentLoading, refetchDocument } =
    useDocument(true);

  const invalidate = async () => {
    await refetchDocument();
    dispatch(api.util.invalidateTags(['Document'])); // Replaces QUERY_KEY_TEMPLATES
  };

  const patchDocument = usePatchDocument();

  const onClick = () => {
    patchDocument.mutate(
      { draft: false, id: currentDocument.id },
      { onSuccess: invalidate },
    );
  };

  if (isDocumentLoading || !currentDocument.draft) return null;

  return (
    <Button variant="outlined" onClick={onClick}>
      Publish Draft
    </Button>
  );
};

export default Publish;
